import * as Yup from 'yup';

export const initialValues = ({ planned_arrival_date = null, products, ...rest }) => ({
  warehouse_id: null,
  planned_arrival_date: (planned_arrival_date && new Date(planned_arrival_date)) || null,
  products: (products?.length && products) || [],
  ...rest,
});
export const productsValidationSchema = Yup.object().shape({
  warehouse_id: Yup.number().required('Warehouse is Required!'),
  planned_arrival_date: Yup.string().nullable().required('Planned Arrival Date is required!'),
  products: Yup.array().of(
    Yup.object().shape({
      consignment_quantity: Yup.number().required('This field is required!'),
    })
  ),
  consignment_number: Yup.string().nullable().required('Consignment Number is required!'),
});
export const ACTIONS = {
  SCHEDULE_INBOUND: 'schedule_inbound',
  RECORD_FEEDBACK: 'record_feedback',
  REMIND_LATER: 'remind_later',
  SCHEDULE_INBOUND_CTA: 'schedule_inbound_cta',
  INBOUND_DRAFT_CREATION: 'inbound_draft_creation',
};

export const TIME_PERIODS = { DAYS: 'DAYS', HOURS: 'HOURS' };
export const remindMeOptions = [
  {
    label: 'Tomorrow',
    value: 1,
    timePeriod: TIME_PERIODS.DAYS,
  },
  {
    label: 'After 3 Days',
    value: 3,
    timePeriod: TIME_PERIODS.DAYS,
  },
  {
    label: 'After 5 Days',
    value: 5,
    timePeriod: TIME_PERIODS.DAYS,
  },
];
